<template>
  <div class="page-container">
    <PageHeader title="通知管理" show-breadcrumb>
      <template #actions>
        <el-button icon="el-icon-check" size="small" @click="handleReadAll">全部已读</el-button>
      </template>
    </PageHeader>

    <SearchPanel>
      <el-input v-model.trim="query.noticeTitle" placeholder="通知标题" clearable size="small" @keyup.enter.native="handleSearch" />
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="通知列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="75" align="center" />
        <el-table-column type="index" width="85" label="序号"  align="center" />
        <el-table-column prop="noticeTitle" label="通知标题"  show-overflow-tooltip />
        <el-table-column prop="noticeContent" label="通知内容"  show-overflow-tooltip />
        <el-table-column prop="auName" label="用户名" width="110" />
        <el-table-column prop="noticeStatus" label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.noticeStatus === 1 ? 'warning' : 'success'" size="mini">{{ row.noticeStatus === 1 ? '未读' : '已读' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="180" />
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="row.noticeStatus === 1" type="text" size="mini" @click="handleRead([row.noticeId])">标为已读</el-button>
            <el-button type="text" size="mini" class="text-danger" @click="handleDelete([row.noticeId])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="batch-actions">
        <el-button size="mini" :disabled="!selectedIds.length" @click="handleRead(selectedIds)">批量已读</el-button>
        <el-button size="mini" type="danger" :disabled="!selectedIds.length" @click="handleDelete(selectedIds)">批量删除</el-button>
      </div>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getSysNoticeList, updateSysNoticeRead, updateSysNoticeReadAll, deleteSysNoticeRead } from '@/api/api'

export default {
  name: 'NoticeList',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      list: [],
      query: { noticeTitle: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      selectedIds: []
    }
  },
  created () { this.fetchList() },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await getSysNoticeList({ ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { noticeTitle: '' }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    handleSelectionChange (rows) { this.selectedIds = rows.map(r => r.noticeId) },
    async handleRead (ids) {
      try {
        await updateSysNoticeRead(ids)
        this.$message.success('已标记为已读')
        this.fetchList()
      } catch (e) {}
    },
    async handleReadAll () {
      try {
        await updateSysNoticeReadAll()
        this.$message.success('已全部标为已读')
        this.fetchList()
      } catch (e) {}
    },
    async handleDelete (ids) {
      await this.$confirm('确认删除选中的通知？', '提示', { type: 'warning' })
      try {
        await deleteSysNoticeRead(ids)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-actions { padding: 10px 20px; border-top: 1px solid #f1f5f9; }
</style>
